/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/google.analytics/index.d.ts" />
/// <reference path="../../node_modules/@types/bootstrap/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery.colorbox/index.d.ts" />

declare var franchiseName: string;
declare var dataLayer: any[] | undefined;

$(() =>
{
    function pushDataLayerEvent(data: any)
    {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
        console.log(data);
    }

    if (document.location.hash.length > 0)
    {
        $(`.nav-tabs a[href='${document.location.hash}']`).tab("show");
    }

    $("#services .summary-link").click(function (ev)
    {
        ev.preventDefault();
        $(`.nav-tabs a[href='#testimonials']`).tab("show");
        $(window).scrollTop($("#franchise-section .tab-content").position().top);
    });

    $("a[rel=gallery]")
        .colorbox({
            maxWidth: "100%",
            maxHeight: "100%",
            transition: "fade",
            photo: true
        });

    $("a[rel=youtube]")
        .colorbox({
            iframe: true,
            innerWidth: 600,
            innerHeight: 480,
            maxWidth: "100%",
            maxHeight: "100%",
            current: "video {current} of {total}"
        });

    // GOOGLE ANALYTICS EVENT TRACKING
    $(".nav-tabs a")
        .click(event =>
        {
            let link = (event.currentTarget as HTMLAnchorElement).href;
            link = link.substring(link.indexOf("#"));
            location.hash = link;

            let name = (event.currentTarget as HTMLAnchorElement).text;
            ga("send", "event", franchiseName, "Tabs", name);
            ga("franchise.send", "event", franchiseName, "Tabs", name);
            pushDataLayerEvent({ "event": "franchise_tab", "tab_name": name });
        });

    $(".prospectus-form input[type=submit]")
        .click(() =>
        {
            pushDataLayerEvent({ "event": "form_submission", "form_name": "Download Franchise Prospectus" });
        });

    $("#contactus input[type=submit]")
        .click(() =>
        {
            pushDataLayerEvent({ "event": "form_submission", "form_name": "Contact Us" });
        });

    $("a.contact-link")
        .click(() =>
        {
            ga("send", "event", franchiseName, "Tabs", "Contact Us");
            ga("franchise.send", "event", franchiseName, "Tabs", "Contact Us");
            pushDataLayerEvent({ "event": "franchise_tab", "tab_name": "Contact Us" });
        });

    $("a.email-link")
        .click(event =>
        {
            ga("send", "event", franchiseName, "Contact", `Clicked ${(event.currentTarget as HTMLAnchorElement).text}`);
            ga("franchise.send", "event", franchiseName, "Contact", `Clicked ${(event.currentTarget as HTMLAnchorElement).text}`);
        });

    $("a.phone-link")
        .click(event => {
            ga("send", "event", franchiseName, "Contact", `Clicked ${(event.currentTarget as HTMLAnchorElement).text}`);
            ga("franchise.send", "event", franchiseName, "Contact", `Clicked ${(event.currentTarget as HTMLAnchorElement).text}`);
        });

    $("a.link-fb")
        .click(() =>
        {
            ga("send", "event", franchiseName, "Social Media", "Clicked Link to Facebook");
            ga("franchise.send", "event", franchiseName, "Social Media", "Clicked Link to Facebook");
        });

    $("a.link-tw")
        .click(() =>
        {
            ga("send", "event", franchiseName, "Social Media", "Clicked Link to Twitter");
            ga("franchise.send", "event", franchiseName, "Social Media", "Clicked Link to Twitter");
        });

    $(".btn-submit")
        .click(() =>
        {
            ga("send", "event", franchiseName, "Forms", "Contact Page Submission");
            ga("franchise.send", "event", franchiseName, "Forms", "Contact Page Submission");
        });
});